export default __webpack_public_path__ + "static/hero-image-10-3ef7b9e5402bc0e8523a7c2c36f7909d.jpeg";